"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_TRANSLATION_KEY_PATTERNS = exports.FormTranslationKeys = exports.ROOMMATE_SELECTION_CHANGE_TRANSLATIONS = exports.FormVersionTranslatableItems = exports.PageTranslatableItems = exports.SectionTranslatableItems = exports.BlockTranslatableItems = exports.FieldTranslatableItems = exports.TranslatableItem = exports.TranslatableItemType = void 0;
/**
 * Enum representing the types of translatable items in a form
 */
var TranslatableItemType;
(function (TranslatableItemType) {
    TranslatableItemType["Page"] = "page";
    TranslatableItemType["Section"] = "section";
    TranslatableItemType["Field"] = "field";
    TranslatableItemType["Block"] = "block";
    TranslatableItemType["Button"] = "button";
    TranslatableItemType["Option"] = "option";
})(TranslatableItemType || (exports.TranslatableItemType = TranslatableItemType = {}));
/**
 * Represents a single translatable item in a form
 */
var TranslatableItem = /** @class */ (function () {
    function TranslatableItem() {
        this.key = '';
        this.type = TranslatableItemType.Field;
        this.defaultValue = '';
        this.label = '';
        this.contextPath = [];
    }
    return TranslatableItem;
}());
exports.TranslatableItem = TranslatableItem;
/**
 * Represents translatable items for a field (standalone field in a section)
 */
var FieldTranslatableItems = /** @class */ (function () {
    function FieldTranslatableItems() {
        this.fieldId = '';
        this.fieldType = '';
        this.items = [];
    }
    return FieldTranslatableItems;
}());
exports.FieldTranslatableItems = FieldTranslatableItems;
/**
 * Represents translatable items for a block
 */
var BlockTranslatableItems = /** @class */ (function () {
    function BlockTranslatableItems() {
        this.blockId = '';
        this.blockName = '';
        this.blockItems = [];
        this.fieldItems = [];
    }
    return BlockTranslatableItems;
}());
exports.BlockTranslatableItems = BlockTranslatableItems;
/**
 * Represents translatable items for a section
 */
var SectionTranslatableItems = /** @class */ (function () {
    function SectionTranslatableItems() {
        this.sectionId = '';
        this.sectionItems = [];
        this.blocks = [];
        this.fields = [];
    }
    return SectionTranslatableItems;
}());
exports.SectionTranslatableItems = SectionTranslatableItems;
/**
 * Represents all translatable items for a single page
 */
var PageTranslatableItems = /** @class */ (function () {
    function PageTranslatableItems() {
        this.pageId = '';
        this.pageName = '';
        this.pageItems = [];
        this.sections = [];
    }
    return PageTranslatableItems;
}());
exports.PageTranslatableItems = PageTranslatableItems;
/**
 * Response containing all translatable items for a form version
 */
var FormVersionTranslatableItems = /** @class */ (function () {
    function FormVersionTranslatableItems() {
        this.pages = [];
    }
    return FormVersionTranslatableItems;
}());
exports.FormVersionTranslatableItems = FormVersionTranslatableItems;
/**
 * Form translation key builders - matches the key patterns used by the translations API
 * when extracting translatable items from form versions (extractPageItems, extractBlockItems, etc).
 * Use these in the form viewer UI instead of hardcoding key strings.
 */
exports.ROOMMATE_SELECTION_CHANGE_TRANSLATIONS = {
    roommateSelectionChangeTitle: 'Leave roommate group?',
    roommateSelectionChangeMessage: 'Saving this new unit or lease selection will remove you from your current roommate group. Do you want to continue?',
};
exports.FormTranslationKeys = {
    page: {
        roommateSelectionChangeTitle: function (pageId) {
            return "form.page.".concat(pageId, ".roommateSelectionChangeTitle");
        },
        roommateSelectionChangeMessage: function (pageId) {
            return "form.page.".concat(pageId, ".roommateSelectionChangeMessage");
        },
        name: function (pageId) { return "form.page.".concat(pageId, ".name"); },
        description: function (pageId) { return "form.page.".concat(pageId, ".description"); },
    },
    section: {
        title: function (sectionId) { return "form.section.".concat(sectionId, ".title"); },
    },
    block: {
        label: function (blockId) { return "form.block.".concat(blockId, ".label"); },
        description: function (blockId) { return "form.block.".concat(blockId, ".description"); },
        /** Simple block field: form.block.{blockId}.field.{fieldName}.label */
        fieldLabel: function (blockId, fieldName) {
            return "form.block.".concat(blockId, ".field.").concat(fieldName, ".label");
        },
        fieldPlaceholder: function (blockId, fieldName) {
            return "form.block.".concat(blockId, ".field.").concat(fieldName, ".placeholder");
        },
        /**
         * Configuration-level item: form.block.{blockId}.{keySuffix}
         * Used for items defined in config-translatable-items.ts, e.g.:
         *   'incomeQuestion.label' → form.block.{blockId}.incomeQuestion.label
         *   'petCount.label' → form.block.{blockId}.petCount.label
         */
        configItem: function (blockId, keySuffix) {
            return "form.block.".concat(blockId, ".").concat(keySuffix);
        },
        /** Block button label: form.block.{blockId}.configuration.buttonLabel */
        buttonLabel: function (blockId) {
            return "form.block.".concat(blockId, ".configuration.buttonLabel");
        },
        /** Block tooltip: form.block.{blockId}.configuration.toolTip */
        toolTip: function (blockId) { return "form.block.".concat(blockId, ".configuration.toolTip"); },
        /** Field option label: form.block.{blockId}.field.{fieldName}.options.{optionId}.label */
        fieldOptionLabel: function (blockId, fieldName, optionId) { return "form.block.".concat(blockId, ".field.").concat(fieldName, ".options.").concat(optionId, ".label"); },
        /** Income type label: form.block.{blockId}.incomeType.{typeName}.label */
        incomeTypeLabel: function (blockId, typeName) {
            return "form.block.".concat(blockId, ".incomeType.").concat(typeName, ".label");
        },
        /** Income type field label: form.block.{blockId}.incomeType.{typeName}.field.{fieldName}.label */
        incomeTypeFieldLabel: function (blockId, typeName, fieldName) {
            return "form.block.".concat(blockId, ".incomeType.").concat(typeName, ".field.").concat(fieldName, ".label");
        },
        /** Income type field placeholder: form.block.{blockId}.incomeType.{typeName}.field.{fieldName}.placeholder */
        incomeTypeFieldPlaceholder: function (blockId, typeName, fieldName) {
            return "form.block.".concat(blockId, ".incomeType.").concat(typeName, ".field.").concat(fieldName, ".placeholder");
        },
        /** Asset type label: form.block.{blockId}.assetType.{typeName}.label */
        assetTypeLabel: function (blockId, typeName) {
            return "form.block.".concat(blockId, ".assetType.").concat(typeName, ".label");
        },
        /** Asset type field label: form.block.{blockId}.assetType.{typeName}.field.{fieldName}.label */
        assetTypeFieldLabel: function (blockId, typeName, fieldName) { return "form.block.".concat(blockId, ".assetType.").concat(typeName, ".field.").concat(fieldName, ".label"); },
        /** Asset type field placeholder: form.block.{blockId}.assetType.{typeName}.field.{fieldName}.placeholder */
        assetTypeFieldPlaceholder: function (blockId, typeName, fieldName) {
            return "form.block.".concat(blockId, ".assetType.").concat(typeName, ".field.").concat(fieldName, ".placeholder");
        },
        /** ID type label: form.block.{blockId}.{idCategory}.{typeName}.label */
        idTypeLabel: function (blockId, idCategory, typeName) {
            return "form.block.".concat(blockId, ".").concat(idCategory, ".").concat(typeName, ".label");
        },
        /** ID type field label: form.block.{blockId}.{idCategory}.{typeName}.field.{fieldName}.label */
        idTypeFieldLabel: function (blockId, idCategory, typeName, fieldName) {
            return "form.block.".concat(blockId, ".").concat(idCategory, ".").concat(typeName, ".field.").concat(fieldName, ".label");
        },
        /** ID type field placeholder: form.block.{blockId}.{idCategory}.{typeName}.field.{fieldName}.placeholder */
        idTypeFieldPlaceholder: function (blockId, idCategory, typeName, fieldName) {
            return "form.block.".concat(blockId, ".").concat(idCategory, ".").concat(typeName, ".field.").concat(fieldName, ".placeholder");
        },
    },
    field: {
        label: function (fieldId) { return "form.field.".concat(fieldId, ".label"); },
        description: function (fieldId) { return "form.field.".concat(fieldId, ".description"); },
        placeholder: function (fieldId) { return "form.field.".concat(fieldId, ".placeholder"); },
        optionLabel: function (fieldId, optionId) {
            return "form.field.".concat(fieldId, ".options.").concat(optionId, ".label");
        },
    },
};
/**
 * Regex patterns for validating form translation keys during CSV import and save.
 * Must be kept in sync with FormTranslationKeys - when adding new key types, add both
 * the builder and the pattern here.
 *
 * Pattern explanation: [\w-]+ matches word characters (letters, digits, underscore) and hyphens.
 * Allows UUIDs (with hyphens), camelCase, PascalCase, snake_case, and kebab-case.
 */
exports.FORM_TRANSLATION_KEY_PATTERNS = [
    // Page keys: form.page.{uuid}.name, form.page.{uuid}.description
    /^form\.page\.[\w-]+\.(name|description|roommateSelectionChangeTitle|roommateSelectionChangeMessage)$/,
    // Section keys: form.section.{uuid}.title
    /^form\.section\.[\w-]+\.title$/,
    // Block keys: form.block.{uuid}.label, form.block.{uuid}.description
    /^form\.block\.[\w-]+\.(label|description)$/,
    // Block configuration keys: form.block.{uuid}.configuration.buttonLabel, form.block.{uuid}.configuration.toolTip
    /^form\.block\.[\w-]+\.configuration\.(buttonLabel|toolTip)$/,
    // Block config-controlled items: form.block.{uuid}.{keySuffix}
    // Examples: incomeQuestion.label, citizenQuestion.label, petCount.label, coapplicantCount.label
    /^form\.block\.[\w-]+\.[\w.]+\.label$/,
    // Block config-controlled options: form.block.{uuid}.{keySuffix}.{optionValue}
    // Examples: incomeQuestion.options.yes, citizenQuestion.options.no
    /^form\.block\.[\w-]+\.[\w.]+\.[\w-]+$/,
    // Block field keys: form.block.{uuid}.field.{fieldName}.label, form.block.{uuid}.field.{fieldName}.placeholder
    /^form\.block\.[\w-]+\.field\.[\w-]+\.(label|placeholder)$/,
    // Block field option keys: form.block.{uuid}.field.{fieldName}.options.{optionId}.label
    /^form\.block\.[\w-]+\.field\.[\w-]+\.options\.[\w-]+\.label$/,
    // Income type keys: form.block.{uuid}.incomeType.{typeName}.label
    /^form\.block\.[\w-]+\.incomeType\.[\w-]+\.label$/,
    // Income type field keys: form.block.{uuid}.incomeType.{typeName}.field.{fieldName}.label
    // Note: Also supports .placeholder suffix (always has one or the other)
    /^form\.block\.[\w-]+\.incomeType\.[\w-]+\.field\.[\w-]+\.(label|placeholder)$/,
    // Asset type keys: form.block.{uuid}.assetType.{typeName}.label
    /^form\.block\.[\w-]+\.assetType\.[\w-]+\.label$/,
    // Asset type field keys: form.block.{uuid}.assetType.{typeName}.field.{fieldName}.label
    // Note: Also supports .placeholder suffix (always has one or the other)
    /^form\.block\.[\w-]+\.assetType\.[\w-]+\.field\.[\w-]+\.(label|placeholder)$/,
    // ID type keys: form.block.{uuid}.{idCategory}.{idTypeName}.label
    // idCategory can be: primaryId, alternateId, additionalPrimaryId
    /^form\.block\.[\w-]+\.[\w-]+\.[\w-]+\.label$/,
    // ID type field keys: form.block.{uuid}.{idCategory}.{idTypeName}.field.{fieldName}.label
    // Note: Currently only .label is generated, but .placeholder is allowed for future use
    /^form\.block\.[\w-]+\.[\w-]+\.[\w-]+\.field\.[\w-]+\.(label|placeholder)$/,
    // Standalone field keys: form.field.{uuid}.label, form.field.{uuid}.placeholder, form.field.{uuid}.description
    // Note: helpText and errorMessage are also valid but may not be commonly used
    /^form\.field\.[\w-]+\.(label|placeholder|description|helpText|errorMessage)$/,
    // Standalone field option keys: form.field.{uuid}.options.{optionId}.label
    /^form\.field\.[\w-]+\.options\.[\w-]+\.label$/,
];
